import React, { useEffect, useRef, useState } from "react";
import Select from 'react-select';

import { useReactFlow } from "reactflow";
import { useTranslation } from "react-i18next";
import selectStyles from '../../../util/selectStyles';
import TextArea from "../../shared/TextArea";
import { CHATBOT_OPTIONS_TYPE } from '../../../constants/AppConstants';
import IconMC from '../../../presentation/components/IconMC';

const TextWithVariables = ({
  chatbotOption,
  setChatbotOption,
  errors,
  customerColumns,
  maxChars = 590,
  classNameTextArea = '',
  nameTextArea = 'answer',
  labelTextArea = 'Texto del mensaje'
}) => {
  const { getNode } = useReactFlow();
  const { t } = useTranslation();

  const textareaRef = useRef(null);

  const [displayProperties, setDisplayProperties] = useState(false);
  const [variableOptions, setVariableOptions] = useState([]);
  const [caretPosition, setCaretPosition] = useState({ start: null });

  useEffect(() => {
    let variables = customerColumns || [];

    if (chatbotOption?.source) {
      const sourceNode = getNode(chatbotOption.source);
      if (sourceNode.source) {
        const source = getNode(sourceNode.source).data;
        if (source?.option?.option_type === CHATBOT_OPTIONS_TYPE.API && source?.option?.api_options) {
          const newApiVariables = source.option.api_options?.variables || [];
          variables = newApiVariables.map((item) => ([t('chatbots.options.api.variable'), item])).concat(variables);
        }
      }
    }

    const options = variables.map((field) => ({
      value: field[1],
      label: (
        <span className="fz-14">
          {field[0]}
          {' '}
          <small className="c-grey">{`{{${field[1]}}}`}</small>
        </span>
      )
    }));

    setVariableOptions(options);
  }, [customerColumns, chatbotOption?.source]);

  const updateInfo = (name, value) => {
    setChatbotOption({
      ...chatbotOption,
      [name]: value
    });
  };

  const handleInputChange = (e) => {
    const { target } = e;
    const { name, value } = target;

    updateInfo(name, value);

    setChatbotOption({
      ...chatbotOption,
      [name]: value
    });
  };

  const handleCaretPosition = (e) => {
    const { selectionStart, selectionEnd } = e.target;

    setCaretPosition({ start: selectionStart, end: selectionEnd, setCaret: true });
  };

  const handleDisplayVariables = () => {
    setDisplayProperties(!displayProperties);
  };

  const handleSelect = (option) => {
    insertFieldInput(option.value);
  };

  const formatedTextToAdd = (value) => {
    let curPos = caretPosition.start;
    const answer = chatbotOption[nameTextArea];

    if (curPos == null) curPos = answer.length;

    const textToAdd = `{{${value}}}`;

    if (curPos === 0 && answer.slice(curPos + 1) === ' ') return textToAdd;
    if (curPos === 0 && answer.slice(curPos + 1) !== ' ') return `${textToAdd} `;

    if (answer.slice(curPos - 1) === ' ' && answer.slice(curPos + 1) !== ' ') return `${textToAdd} `;
    if (answer.slice(curPos - 1) !== ' ' && answer.slice(curPos + 1) === ' ') return ` ${textToAdd}`;
    if (answer.slice(curPos - 1) !== ' ' && answer.slice(curPos + 1) === '') return ` ${textToAdd}`;

    return ` ${textToAdd} `;
  };

  const insertFieldInput = (value) => {
    let curPos = caretPosition.start;
    const answer = chatbotOption[nameTextArea];

    if (curPos == null) curPos = answer.length;

    const textToAdd = formatedTextToAdd(value);

    const newAnswer = answer.slice(0, curPos) + textToAdd + answer.slice(curPos);

    updateInfo(nameTextArea, newAnswer);
    setDisplayProperties(false);
  };

  return (
    <>
      <div className="col-md-12 mt-10">
        <TextArea
          label={labelTextArea}
          className={classNameTextArea}
          errors={errors[nameTextArea]}
          textareaRef={textareaRef}
          name={nameTextArea}
          value={chatbotOption[nameTextArea] || ''}
          onChange={handleInputChange}
          onFocus={handleCaretPosition}
          onBlur={handleCaretPosition}
          counter
          maxChars={maxChars}
        />
      </div>

      {!displayProperties && (
        <div className="col-md-12 mt-10 mb-10 text-right">
          <button type="button" className="chats-add-note-button" onClick={handleDisplayVariables}>
            <span className="text-blue fz-14">Añadir variable</span>
          </button>
        </div>
      )}

      {displayProperties && (
        <div className="col-md-12 d-flex flex-row mt-20 justify-content-between">
          <div className="col-md-11 px-0">
            <div className="figma-field mb-0">
              <label>Variables</label>
              <Select
                options={variableOptions}
                placeholder="selecciona un campo"
                className="select-tag"
                classNamePrefix="select-tag"
                styles={selectStyles}
                onChange={handleSelect}
                components={{
                  IndicatorSeparator: () => null
                }}
              />
            </div>
          </div>
          <div className="d-flex align-items-center">
            <button
              type="button"
              onClick={handleDisplayVariables}
              className="tw-flex tw-cursor-pointer tw-items-center tw-border-0 tw-bg-transparent tw-p-1 tw-text-gray-700"
              aria-label="Cerrar selector de variables"
            >
              <IconMC name="close-outline" size="xl" />
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default TextWithVariables;
